module.exports = __webpack_public_path__ + "img/block1.7890ef01.png";